import { render } from "./UsersListDownload.vue?vue&type=template&id=2049434e&scoped=true"
import script from "./UsersListDownload.vue?vue&type=script&lang=js"
export * from "./UsersListDownload.vue?vue&type=script&lang=js"

import "./UsersListDownload.vue?vue&type=style&index=0&id=2049434e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2049434e"]])

export default __exports__